import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import {
  FulfilledBy,
  FulfillmentGroupData,
  getFulfillmentGroupValue,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExplicitInsuredParcelsValue } from "@redotech/redo-fulfillment-operations-common/fulfillment-group-insurance";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries.insured;

type InsuranceStatus = "fully-insured" | "partially-insured" | "none";

function getInsuranceStatus(row: FulfillmentGroupData): InsuranceStatus {
  if (row.fulfilledBy !== FulfilledBy.REDO) {
    return "none";
  }

  const totalInsuredAmount = getExplicitInsuredParcelsValue(row);
  const totalGroupValue = getFulfillmentGroupValue(row);

  if (totalInsuredAmount >= totalGroupValue) {
    return "fully-insured";
  }

  // Everything bought in Redo is partially insured
  return "partially-insured";
}

export const ShippingInsuranceColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    const status = getInsuranceStatus(row);

    return (
      <Flex pl="lg">
        {status === "fully-insured" && (
          <RedoBadge
            color="success"
            size="xs"
            text="Fully insured"
            type="primary"
          />
        )}
        {status === "partially-insured" && (
          <RedoBadge
            color="warning"
            size="xs"
            text="Partially insured"
            type="primary"
          />
        )}
      </Flex>
    );
  },
  width: catalogEntry.defaultWidth,
};
